import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

const TimestampConverterTool = () => {
  const [timestamp, setTimestamp] = useState('');
  const [dateString, setDateString] = useState('');
  const [currentTime, setCurrentTime] = useState(Date.now());

  const convertTimestamp = () => {
    if (!timestamp) return;
    try {
      const ts = parseInt(timestamp);
      const date = new Date(ts.toString().length === 10 ? ts * 1000 : ts);
      setDateString(date.toISOString());
      toast.success('Converted!');
    } catch (e) {
      toast.error('Invalid timestamp');
    }
  };

  const convertDate = () => {
    if (!dateString) return;
    try {
      const date = new Date(dateString);
      setTimestamp(date.getTime().toString());
      toast.success('Converted!');
    } catch (e) {
      toast.error('Invalid date');
    }
  };

  const refreshCurrent = () => {
    setCurrentTime(Date.now());
  };

  const copyValue = (value) => {
    navigator.clipboard.writeText(value);
    toast.success('Copied!');
  };

  return (
    <div className="space-y-4" data-testid="timestamp-converter-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">Timestamp Converter</h3>
      </div>

      {/* Current Time */}
      <div className="p-4 rounded-lg bg-primary/10 border border-primary/30">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-muted-foreground">Current Time</span>
          <Button variant="ghost" size="sm" onClick={refreshCurrent}>Refresh</Button>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs text-muted-foreground">Unix (ms)</div>
            <div className="flex gap-1">
              <Input value={currentTime} readOnly className="font-mono text-sm bg-background/50" />
              <Button variant="ghost" size="sm" onClick={() => copyValue(currentTime.toString())}>
                <Copy className="w-4 h-4" />
              </Button>
            </div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground">ISO 8601</div>
            <div className="flex gap-1">
              <Input value={new Date(currentTime).toISOString()} readOnly className="font-mono text-sm bg-background/50" />
              <Button variant="ghost" size="sm" onClick={() => copyValue(new Date(currentTime).toISOString())}>
                <Copy className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Timestamp to Date */}
      <div className="space-y-2">
        <label className="text-sm text-muted-foreground">Timestamp to Date</label>
        <div className="flex gap-2">
          <Input
            placeholder="Enter Unix timestamp..."
            value={timestamp}
            onChange={(e) => setTimestamp(e.target.value)}
            className="font-mono bg-background/50"
            data-testid="timestamp-input"
          />
          <Button onClick={convertTimestamp}>Convert</Button>
        </div>
      </div>

      {/* Date to Timestamp */}
      <div className="space-y-2">
        <label className="text-sm text-muted-foreground">Date to Timestamp</label>
        <div className="flex gap-2">
          <Input
            type="datetime-local"
            value={dateString ? dateString.slice(0, 16) : ''}
            onChange={(e) => setDateString(e.target.value)}
            className="bg-background/50"
            data-testid="date-input"
          />
          <Button onClick={convertDate}>Convert</Button>
        </div>
      </div>

      {dateString && (
        <div className="p-3 rounded bg-background/50 border border-border">
          <div className="text-xs text-muted-foreground mb-1">Result</div>
          <div className="font-mono text-sm">{dateString}</div>
        </div>
      )}
    </div>
  );
};

export default TimestampConverterTool;
